module.exports = __webpack_public_path__ + "static/media/redmond.d2249e85.jpg";